import { useEffect, useState, useCallback } from "react";
import ReactPlayer from "react-player";
import { Row, Col } from "react-flexbox-grid";
import { PageWrapper } from "components";
import { fetchBackend } from "helpers";
import { useGlobalContext } from "context/GlobalContext";
import { useParams } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import { withLoader } from "HOC";
import styled from "styled-components";

const DivStyled = styled.div`
  margin: 0 auto;
  width: 100%;
  height: 400px;
  @media (min-width: 768px) {
    width: 100%;
    height: 650px;
  }
  opacity: 0;
  visibility: hidden;
  transition: all 2s ease-out;
  &.loaded {
    opacity: 1;
    visibility: visible;
  }
`;

const SingleNotification = ({ setLoading }) => {
  const [dataSource, setDataSource] = useState(null);
  const [isChargin, setChargin] = useState(true);
  const gContext = useGlobalContext();
  const { id } = useParams();

  const getNotifications = useCallback(async (notification) => {
    const { error, response } = await fetchBackend({
      url: `notification/${notification}`,
    });
    if (!error) {
      setDataSource(response[0]);
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar obtener los datos de la notificación, revisa tu conexión a internet",
        type: "error",
      });
    }
  }, []);

  const getInitialState = useCallback(async () => {
    if (id) {
      await Promise.all([getNotifications(id)]);
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    getInitialState();
  }, [getInitialState]);

  return (
    <PageWrapper
      isBack
      header={
        <Row start="xs">
          <Col md={12}>
            <Row center="xs">
              <h1>Notificación</h1>
            </Row>
          </Col>
        </Row>
      }
    >
      <Col md={12}>
        <Row center="xs">
          <Col md={12}>
            <Typography variant="h6" color="textPrimary">
              {dataSource?.title}
            </Typography>
            <Typography variant="body1" color="textSecondary">
              {dataSource?.description}
            </Typography>
          </Col>
          <Col md={12} className="mt3">
            <DivStyled className={`${isChargin ? "loading" : "loaded"}`}>
              <ReactPlayer
                url={dataSource?.video}
                light={dataSource?.image}
                width="100%"
                height="100%"
                controls
                autoplay
                onReady={() => {
                  setChargin(false);
                }}
              />
            </DivStyled>
          </Col>
        </Row>
      </Col>
    </PageWrapper>
  );
};

export default withLoader(SingleNotification, "Cargando notificación");
